import { defineMessages, IntlShape } from "react-intl";

enum CardFeature {
  ACTIVITIES = "activities",
  COMPANIES = "companies",
  DEALS = "deals",
  GOAL = "goal",
  PEOPLE = "people",
}

const messages = defineMessages<"all" | CardFeature>({
  all: {
    id: "dashboard.addEditCard.cardFeature.all",
    defaultMessage: "All",
    description: "All card feature option",
  },
  [CardFeature.ACTIVITIES]: {
    id: "dashboard.addEditCard.cardFeature.activities",
    defaultMessage: "Activities",
    description: "Activities card feature",
  },
  [CardFeature.COMPANIES]: {
    id: "dashboard.addEditCard.cardFeature.companies",
    defaultMessage: "Companies",
    description: "Companies card feature",
  },
  [CardFeature.DEALS]: {
    id: "dashboard.addEditCard.cardFeature.deals",
    defaultMessage: "Deals",
    description: "Deals card feature",
  },
  [CardFeature.GOAL]: {
    id: "dashboard.addEditCard.cardFeature.goal",
    defaultMessage: "Goal compatible",
    description: "Goal card feature",
  },
  [CardFeature.PEOPLE]: {
    id: "dashboard.addEditCard.cardFeature.people",
    defaultMessage: "People",
    description: "People card feature",
  },
});

export const getCardFeatureDisplayName = (intl: IntlShape, cardFeature?: CardFeature) =>
  intl.formatMessage(cardFeature ? messages[cardFeature] : messages.all);

export default CardFeature;
